<template>
	<BaseCmsPage v-slot="{page}">
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>

		<section class="main">
			<div class="wider-wrapper">
				<div class="main-content">
					<div class="cms-content">
						<ClientOnly>
							<LazyBaseThemeWebshopAlternatePayments v-if="altPayments" />
							<template v-else>
								<div class="cms-content"><div v-if="page?.content" v-html="page.content" v-interpolation /></div>
							</template>
							<template #fallback>
								<div style="text-align: center"><UiLoader color="black" /></div>
							</template>
						</ClientOnly>
					</div>
				</div>
			</div>
		</section>
	</BaseCmsPage>
</template>

<script setup>
	const altPayments = __ALT_PAYMENTS__;
</script>

<style lang="less" scoped>
</style>
